<template>
  <div class="col-9">
    <strong>{{ item.text }}</strong>
    <textarea
      v-if="!item.is_multichoice"
      type="text"
      name="answer"
      @input="setAnswer('text', $event.target.value)"
      :value="getAnswerText()"
    />
    <div v-if="item.is_multichoice">
      <div v-for="val in [1, 2, 3, 4, 5, 6]" :key="`item-${item.id}-${val}`">
        <div class="form-ext-control form-ext-radio" v-if="showInput(val)">
          <input
            :id="getId(val)"
            :name="getName()"
            @click="setAnswer('choice', $event.target.value)"
            :value="val"
            :checked="checkAnswer(val)"
            class="form-ext-input"
            type="radio"
          />
          <label class="form-ext-label" :for="getId(val)">{{
            getChoice(val)
          }}</label>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import { debounce } from "@/functions/debounce.function";

export default {
  name: "exam-item-complete",
  data: function() {
    return {
      label: "",
      idx: 0
    };
  },
  props: {
    item: {}
  },
  methods: {
    getId: function(idx) {
      return this.item.id + "-" + idx;
    },
    getName: function() {
      return "item-" + this.item.id;
    },
    getChoice(num) {
      var key = "choice_" + String(num);
      return this.item[key];
    },
    showInput: function(idx) {
      return this.getChoice(idx).length > 0;
    },
    checkAnswer: function(idx) {
      // Ensure that the already selected answer is selected when the page
      // is re-loaded
      const choice = this.item["choice_" + idx];
      if (choice == this.item.answer) {
        return true;
      } else {
        return false;
      }
    },
    getAnswerText() {
      return this.item.answer;
    },
    setAnswer: debounce(function(type, value) {
      var answer = String;
      if (type == "text") {
        answer = value;
      } else if (type == "choice") {
        answer = this.item["choice_" + value];
      }
      const payload = {
        examId: this.$route.params.id,
        itemId: this.item.id,
        answer: answer
      };
      this.$store.dispatch("exams/updateItem", payload);
    }, 500)
  }
};
</script>
